export default "__VITE_ASSET__DKfAbBYU__"